import { CanActivateChildFn } from '@angular/router';
import { NotFoundError } from '../errors';

export const NotFoundGuard: CanActivateChildFn = () => {
  throw new NotFoundError('Page non trouvée.');
};
